import {createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw} from 'vue-router';

const routes: RouteRecordRaw[] = [
    // 启蒙好课官网页面
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/home.vue')
    },
    // 课程介绍
    {
        path: '/courseIntroduce',
        name: 'courseIntroduce',
        component: () => import(/* webpackChunkName: "test" */'@/views/courseIntroduce.vue')
    },

    // 个人信息保护政策
    {
        path: '/policy',
        name: 'policy',
        component: () => import('@/views/policy.vue')
    },
    // 儿童隐私协议
    {
        path: '/policychild',
        name: 'policychild',
        component: () => import('@/views/policy.vue')
    },
    // 用户服务协议
    {
        path: '/policyprotocol',
        name: 'policyprotocol',
        component: () => import('@/views/policy.vue')
    },
    // 其他的重定向到首页
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory('/'),
    routes
});

// console.log(222);
// router.beforeEach((to, from, next) => {
//     console.log(to);
// });

export default router;
